module.exports = __webpack_public_path__ + "assets/img/Pioneer_005.81b4dcd4-ps.jpg";